import { defineMessages } from 'react-intl';

export const messages: {
	unsplashLegal: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	unsplashLicenseLink: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	unsplashNoMoreResultsToLoadText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	unsplashNoResultsText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	unsplashLoadMoreAriaLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	unsplashTermsOfServiceLink: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	unsplashResultsCount: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	unsplashNoResultsAnnouncement: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	unsplashSearchResultsLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	unsplashNoResultsText: {
		id: 'company-hub.company-hub-common.unsplash.search.no.results.text',
		defaultMessage: 'Nothing matches your search',
		description: 'Text to inform when there are no Unsplash image results to render',
	},
	unsplashLoadMoreAriaLabel: {
		id: 'company-hub.company-hub-common.unsplash.search.load-more.aria-label',
		defaultMessage: 'Load more header images',
		description: 'Accessible label for the button to load more Unsplash header images',
	},
	unsplashNoMoreResultsToLoadText: {
		id: 'company-hub.company-hub-common.unsplash.search.no.more.results.to.load.text',
		defaultMessage: 'No more matches try another search',
		description: 'Text to inform when there are no more Unsplash image results to load',
	},
	unsplashLegal: {
		id: 'company-hub.company-hub-common.unsplash.legal',
		defaultMessage:
			'By using images from Unsplash, you agree to their {unsplashLicenseLink} and {unsplashTermsOfServiceLink}.',
		description: 'Text that explains the Unsplash legal agreements (license and terms of service)',
	},
	unsplashLicenseLink: {
		id: 'company-hub.company-hub-common.unsplash.license',
		defaultMessage: 'license',
		description:
			'The text is shown as a hyperlink inside the Unsplash legal agreement notice in the image search panel, linking to the Unsplash license page.',
	},
	unsplashTermsOfServiceLink: {
		id: 'company-hub.company-hub-common.unsplash.terms.of.service.',
		defaultMessage: 'Terms of Service',
		description: 'Text that links to Unsplash Terms of Service',
	},
	unsplashResultsCount: {
		id: 'company-hub.company-hub-common.unsplash.search.results.count',
		defaultMessage: '{count} results found',
		description:
			'Announced to screen reader users when Unsplash search results load, indicating the number of results found',
	},
	unsplashNoResultsAnnouncement: {
		id: 'company-hub.company-hub-common.unsplash.search.no.results.announcement',
		defaultMessage: 'No results found',
		description: 'Announced to screen reader users when an Unsplash search returns no results',
	},
	unsplashSearchResultsLabel: {
		id: 'company-hub.company-hub-common.unsplash.search.results.label',
		defaultMessage: 'Search results',
		description: 'Accessible label for the Unsplash search results listbox',
	},
});
